import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { HrefPreventDefaultDirective } from '../../_directives/href-prevent-default.directive'
import { UnwrapTagDirective } from '../../_directives/unwrap-tag.directive'
import { EACDSComponent } from '../eacds/eacds.component'
import { SharedModule } from '../shared/index'
import { AsideNavComponent, FrontendUpdateBar } from './aside-nav/aside-nav.component'
import { HeaderNavComponent } from './header-nav/header-nav.component'
import { LayoutComponent } from './layout/layout.component'
import { QuickSidebarComponent } from './quick-sidebar/quick-sidebar.component'
import { ScrollTopComponent } from './scroll-top/scroll-top.component'

@NgModule({
  declarations: [
    LayoutComponent,
    HeaderNavComponent,
    EACDSComponent,
    FrontendUpdateBar,
    AsideNavComponent,
    QuickSidebarComponent,
    ScrollTopComponent,
    HrefPreventDefaultDirective,
    UnwrapTagDirective
  ],
  exports: [
    LayoutComponent,
    HeaderNavComponent,
    EACDSComponent,
    AsideNavComponent,
    QuickSidebarComponent,
    ScrollTopComponent,
    HrefPreventDefaultDirective
  ],
  entryComponents: [FrontendUpdateBar],
  imports: [CommonModule, RouterModule, SharedModule,]
})
export class LayoutModule { }
